<ion-content>
	<div class="wrapper">
		@for (optionGroup of optionGroups; track $index) {
			<div class="wrapper-header">
				<h2 class="title">
					{{ (optionGroup.description | langObservable | async) || (optionGroup.name | langObservable | async) }}
				</h2>
				<div class="content">
					<!-- <app-article-option-group-checkbox
					(selection)="addOption($event)"
					[currency]="order?.currency"
					[optionGroupValue]="optionGroup"
					[preorderType]="order.preorder.type"
					[selected]="checkIfSelected(optionGroup)">
				</app-article-option-group-checkbox> -->

					<app-article-option-group-custom
						(selection)="addOption($event, optionGroup)"
						[article]="articleGroup.article"
						[currency]="order && order?.currency"
						[optionGroup]="optionGroup"
						[showAllButton]="false"
						[preorderType]="order.preorder.type"
						[selected]="this.listOfArticleOptions"
					>
					</app-article-option-group-custom>
				</div>
			</div>
		}
	</div>
</ion-content>

<ion-footer>
	<div class="footer_block">
		<ion-button (click)="select()">
			{{ 'email_confirmation.select' | translate }}
		</ion-button>
		<ion-button (click)="close()" class="cancel_btn" aria-label="Cancel">
			{{ 'email_confirmation.close' | translate }}
		</ion-button>
	</div>
</ion-footer>
